import React from "react";
import MuiRadio from "@mui/material/Radio";
import PropTypes from "prop-types";

/**
 * Radio component wrapper for radio button inputs.
 * Wraps Material-UI Radio with theme integration.
 * 
 * @component
 * @example
 * <Radio
 *   checked={selectedValue === 'a'}
 *   onChange={handleChange}
 *   value="a"
 * />
 */
const Radio = (props) => {
  return <MuiRadio {...props} />;
};

Radio.propTypes = {
  /**
   * If true, the component is checked
   */
  checked: PropTypes.bool,
  /**
   * The icon to display when the component is checked
   */
  checkedIcon: PropTypes.node,
  /**
   * The color of the component
   */
  color: PropTypes.oneOf([
    "default",
    "primary",
    "secondary",
    "error",
    "info",
    "success",
    "warning",
  ]),
  /**
   * If true, the component will be disabled
   */
  disabled: PropTypes.bool,
  /**
   * If true, the ripple effect will be disabled
   */
  disableRipple: PropTypes.bool,
  /**
   * The icon to display when the component is unchecked
   */
  icon: PropTypes.node,
  /**
   * The id of the input element
   */
  id: PropTypes.string,
  /**
   * Attributes applied to the input element
   */
  inputProps: PropTypes.object,
  /**
   * Name attribute of the input element
   */
  name: PropTypes.string,
  /**
   * Callback fired when the state is changed
   */
  onChange: PropTypes.func,
  /**
   * If true, the input element will be required
   */
  required: PropTypes.bool,
  /**
   * The size of the component
   */
  size: PropTypes.oneOf(["small", "medium", "large"]),
  /**
   * The value of the component
   */
  value: PropTypes.any,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles
   */
  sx: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])
    ),
    PropTypes.func,
    PropTypes.object,
  ]),
};

// No defaultProps - maintain exact MUI Radio behavior
// MUI Radio defaults: color="primary", size="medium"

export default Radio;

